function toTitleCase(value: string): string {
  const acronyms = new Set(['ceo', 'cfo', 'cto', 'coo', 'cio', 'chro', 'it', 'ai', 'ui', 'ux', 'okr', 'okrs']);
  return value
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => {
      const lower = word.toLowerCase();
      if (acronyms.has(lower)) return lower.toUpperCase();
      return lower.slice(0, 1).toUpperCase() + lower.slice(1);
    })
    .join(' ');
}

function isProbablyInternalId(bare: string): boolean {
  const v = String(bare ?? '').trim();
  if (!v) return true;

  // Common generated/internal forms we never want to show as UI labels.
  if (/^(POS_|TMP_|TEMP_)/i.test(v)) return true;
  if (/^P\d{2,}$/i.test(v)) return true;
  if (/^[a-f0-9]{12,}$/i.test(v)) return true;

  // All-caps/underscore IDs (but avoid short human-ish tokens like CEO).
  if (/^[A-Z0-9_]{6,}$/.test(v)) return true;

  return false;
}

export function formatScopeRootNodeIdForUi(scopeRootNodeId: string): string {
  const raw = String(scopeRootNodeId ?? '').trim();
  const bare = raw.replace(/^pos:/i, '');
  if (isProbablyInternalId(bare)) return 'Governed planning scope';

  const normalized = bare.replace(/[_-]+/g, ' ').trim();
  if (!normalized) return 'Governed planning scope';
  return toTitleCase(normalized);
}
